<template>
  <div>
    <v-tooltip v-if="showLock" location="top">
      <template v-slot:activator="{ props }">
        <span class="feature-title-span" v-bind="props">
          <v-badge color="error" icon="mdi-lock">
            <span class="feature-title__title">{{ title }}</span>
          </v-badge>
        </span>
      </template>
      <span>{{ toolTipMessage }}</span>
    </v-tooltip>
    <span v-else class="feature-title__title">{{ title }}</span>
  </div>
</template>

<script lang="ts" setup>
import {computed} from 'vue';
import {useSubscription} from '@/composables/useSubscription';

const props = defineProps<{
  title: string;
  featureBasic?: boolean;
  featureStandard?: boolean;
  featurePremium?: boolean;
}>();

const {subscriptionStatus, subscriptionPlan} = useSubscription();

const showLock = computed(() => {
  return subscriptionStatus.value !== 'active' ||
    (subscriptionPlan.value === 'basic' && !props.featureBasic) ||
    (subscriptionPlan.value === 'standard' && !props.featureStandard) ||
    (subscriptionPlan.value === 'premium' && !props.featurePremium);
});

const toolTipMessage = computed(() => {
  const features = [];
  if (props.featureBasic) features.push('Basic');
  if (props.featureStandard) features.push('Standard');
  if (props.featurePremium) features.push('Premium');

  return features.length ? `${features.join(', ')} Feature` : '';
});
</script>

<style scoped>
.feature-title-span .feature-title__title,
.feature-title__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: .0125em;
  line-height: 2rem;
  word-break: break-all;
}
</style>
